.qpsPushProgressIndicator {
  box-shadow: var(--elevation-3);
  border-top: 8px solid var(--color-primary-400);
  background: white;
  width: 312px;
  padding: 16px;

  /* Enter Animation */
  animation-duration: 0.1s;
  animation-name: slideup;
}

.completed {
  gap: 32px;
  display: grid;
  grid-template-columns: 1fr auto auto;

  a svg,
  button svg {
    color: var(--color-tertiary-700);
  }
}

.clientsContainer {
  overflow-y: auto;
  max-height: 300px;
  margin-top: 16px;
  margin-left: -16px;
  margin-right: -16px;

  > * {
    margin-left: 16px;
    margin-right: 16px;
  }

  /* Collapse/Expand Animation */
  --transition-duration: 0.1s;

  animation: hidescroll var(--transition-duration) backwards;
  interpolate-size: allow-keywords;
  transition-duration: var(--transition-duration);
  transition-timing-function: var(--ease-out);
  transition-property: height, margin;
}

.clientsContainer__collapsed {
  overflow-y: hidden;
  height: 0;
  margin-top: 0;
  animation: none;
}

@keyframes hidescroll {
  from,
  to {
    overflow-y: hidden;
  }
}

@keyframes slideup {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
